module.exports = __webpack_public_path__ + "images/Bubbles_OrangeandMandarin_2.png";